import { TypedUseSelectorHook, useDispatch, useSelector } from "react-redux";
import type { RootState, AppDispatch } from "@/store/store";

type DispatchFunc = () => AppDispatch;
export const useAppDispatch: DispatchFunc = useDispatch;
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;
export { default as useConfirmation } from "./useConfirmation";
export { default as useQuery } from "./useQuery";
export { default as useOrder } from "./useOrder";
export { default as useOrderDetails } from "./useOrderDetails";
export { default as useResponsive } from "./useResponsive";
export { default as useUserProfile } from "./useUserProfile";
export { default as useOrganizationPlan } from "./useOrganizationPlan";
export { default as useMenuNavigation } from "./useMenuNavigation";
export { default as useOriginalImage } from "./useOriginalImage";
export { default as useTerminology } from "./useTerminology";


